const INJECT_KEY = "__inject__";
// eslint-disable-next-line @typescript-eslint/ban-types
export function getInjectedData(Service) {
    if (Reflect.hasMetadata(INJECT_KEY, Service)) {
        return Reflect.getMetadata(INJECT_KEY, Service);
    }
    const data = {
        properties: [],
        parameters: new Array(Service.constructor.length),
        postInjection: [],
    };
    Reflect.defineMetadata(INJECT_KEY, data, Service);
    return data;
}
